<template>
  <div id="modalEvent">
    <Modal
      v-show="isModalVisible"
      @close="closeModal"
    >
      <template v-slot:header>
      
      </template>

      <template v-slot:body>
       <img src="" alt="" width="100%" height="auto">
      </template>

      <template v-slot:footer>
       
      </template>
    </Modal>
    
  </div>
</template>

<script>
// import $ from "jquery";
import Modal from './modal.vue';
export default {
 
  name: "modalEvent",
  mounted() {

    // $('#exampleModal').modal();
  },
  components: {
      Modal,
    },
    data() {
      return {
        isModalVisible: true,
      };
    },
    methods: {
      showModal() {
        this.isModalVisible = true;
      },
      closeModal() {
        this.isModalVisible = false;
      }
    }
};

</script>

<style scoped></style>
